module.exports = __webpack_public_path__ + "static/img/visual_title.a3eb44d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/daas_case/visual_title.png
// module id = toXC
// module chunks = 0